module.exports = __webpack_public_path__ + "static/media/lightbox_delete_icon_hover.666740b4.svg";